/*eslint-disable*/
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import { List, ListItem, withStyles } from "@material-ui/core";
import { Link } from "gatsby"

// @material-ui/icons
import Favorite from "@material-ui/icons/Favorite";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

import footerStyle from "assets/jss/material-kit-react/components/footerStyle.jsx";

import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import SocialMediaLinks from "components/SocialMediaLinks/SocialMediaLinks.jsx";

function Footer({ ...props }) {
  const { classes, whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
      <GridContainer justify="flex-start">
        <GridItem xs={12} md={4} className={classes.gridItem}>
              <List className={classes.list} role="navigation">
                <ListItem alignItems="flex-start" className={classes.listItem + " " + classes.listItemFirst}>
                  <Link
                    to="/about/"
                    className={classes.listItem + " " + classes.listItemFirst}
                  >
                    About
                  </Link>
                </ListItem>
                <ListItem alignItems="flex-start" className={classes.listItem}>
                  <Link
                    to="/about#mission-statement"
                    className={classes.listItem}
                  >
                    Mission Statement
                  </Link>
                </ListItem>
                <ListItem alignItems="flex-start" className={classes.listItem}>
                  <Link
                    to="/about#public-benefit-statement"
                    className={classes.listItem}
                  >
                    Public Benefit Statement
                  </Link>
                </ListItem>
                <ListItem alignItems="flex-start" className={classes.listItem}>
                  <Link
                    to="/about#team"
                    className={classes.listItem}
                  >
                    Team
                  </Link>
                </ListItem>
                <ListItem alignItems="flex-start" className={classes.listItem}>
                  <Link
                    to="/blog/"
                    className={classes.listItem}
                  >
                    Blog
                  </Link>
                </ListItem>
              </List>
        </GridItem>
        <GridItem xs={12} md={4} className={classes.gridItem}>
              <List className={classes.list}>
                <ListItem alignItems="flex-start" className={classes.listItem + " " + classes.listItemFirst}>
                    Products
                </ListItem>
                <ListItem alignItems="flex-start" className={classes.listItem}>
                  <Link
                    to="/athena/"
                    className={classes.listItem}
                    target=""
                  >
                    Athena
                  </Link>
                </ListItem>
                <ListItem alignItems="flex-start" className={classes.listItem}>
                  <Link
                    to="/votingfunds/"
                    className={classes.listItem}
                  >
                    Voting Funds
                  </Link>
                </ListItem>
              </List>
        </GridItem>
        <GridItem xs={12} className={classes.gridItem}>
          <div className={classes.block + " " + classes.disclaimer}>
            Disclaimer: Nothing on this site shall be construed as an offer to sell securities, as investment advice, as legal advice, or as tax advice. We the Shareholders PBC does not currently sell, trade, distribute, or advise on securities. We the Shareholders PBC is currently neither registered nor in the process of registering under the 1940 Investment Company Act. We the Shareholders PBC is currently neither a broker-dealer nor a registered investment advisor.
          </div>
        </GridItem>
        <GridItem xs={12} className={classes.gridItem}>
          <div className={classes.block + " " + classes.copyright}>
            &copy; {1900 + new Date().getYear()} We the Shareholders PBC
          </div>
          <SocialMediaLinks classes={classes}/>
        </GridItem>
      </GridContainer>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  whiteFont: PropTypes.bool
};

export default withStyles(footerStyle)(Footer);
